import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type MgsaDraftStateFragment = { mindsets?: Array<{ name: string, description?: string | null }> | null, goals?: Array<{ name: string, description?: string | null }> | null, skillGroups?: Array<{ skillGroupName: string, skills: Array<{ description?: string | null, expectedScore: number, name: string, reviewerScore: number }> }> | null, activities?: Array<{ activityEntityId?: string | null, activityType: Types.MgsaActivityTypeEnum, description?: string | null, draftOkr?: string | null }> | null, overriddenMgsaPropertiesConfig?: { skillOverridden?: boolean | null, mindsetOverridden?: boolean | null, goalOverridden?: boolean | null, activityOverridden?: boolean | null } | null };


export type MgsaDraftStateFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const MgsaDraftStateFragmentDoc = /*#__PURE__*/ gql`
    fragment MgsaDraftState on MgsaDraftStateType {
  mindsets {
    name
    description
  }
  goals {
    name
    description
  }
  skillGroups {
    skills {
      description
      expectedScore
      name
      reviewerScore
    }
    skillGroupName
  }
  activities {
    activityEntityId
    activityType
    description
    draftOkr
  }
  overriddenMgsaPropertiesConfig {
    skillOverridden
    mindsetOverridden
    goalOverridden
    activityOverridden
  }
}
    `;